import React from 'react';
import { Flex, Typography } from 'antd';
import moment from 'moment';
import TransactionListItem from './TransactionListItem';
import { Transaction } from '../model/types';

export type TransactionItem = {
  date: string;
  transactions: Transaction[];
};

type TransactionsListProps = {
  transactions: Record<string, Transaction[]>;
  onClickTransaction: (transaction: Transaction) => void;
};

const TransactionsList: React.FC<TransactionsListProps> = ({
  transactions,
  onClickTransaction
}) => {
  const renderHeader = (date: string) => {
    return <Typography.Text strong>{moment(date, 'DD-MM-YYYY').format('LL')}</Typography.Text>;
  };

  const renderTransactionItem = (transaction: Transaction) => {
    return (
      <TransactionListItem
        key={transaction.id}
        transaction={transaction}
        onClick={onClickTransaction}
      />
    );
  };

  return (
    <Flex vertical>
      {Object.entries(transactions).map(([date, transactions]) => (
        <Flex key={date} vertical gap={16}>
          {renderHeader(date)}
          <Flex vertical>
            {transactions.map((transaction) => renderTransactionItem(transaction))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default TransactionsList;
